import React from 'react'
import {Icon} from '@chakra-ui/react'
const CrossIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                d="M20.928 4.058C20.838 3.842 20.658 3.662 20.442 3.572C20.334 3.527 20.217 3.5 20.1 3.5H14.7C14.205 3.5 13.8 3.905 13.8 4.4C13.8 4.895 14.205 5.3 14.7 5.3H17.931L13.17 10.061C12.819 10.412 12.819 10.979 13.17 11.33C13.35 11.51 13.575 11.591 13.809 11.591C14.043 11.591 14.268 11.501 14.448 11.33L19.209 6.569V9.8C19.209 10.295 19.614 10.7 20.109 10.7C20.604 10.7 21.009 10.295 21.009 9.8V4.4C21.009 4.283 20.982 4.166 20.937 4.058H20.928Z"
                fill="currentColor"
            />
            <path
                d="M9.561 13.661L4.8 18.422V15.191C4.8 14.696 4.395 14.291 3.9 14.291C3.405 14.291 3 14.696 3 15.191V20.591C3 20.708 3.027 20.825 3.072 20.933C3.162 21.149 3.342 21.329 3.558 21.419C3.666 21.464 3.783 21.491 3.9 21.491H9.3C9.795 21.491 10.2 21.086 10.2 20.591C10.2 20.096 9.795 19.691 9.3 19.691H6.069L10.83 14.93C11.181 14.579 11.181 14.012 10.83 13.661C10.479 13.31 9.912 13.31 9.561 13.661Z"
                fill="currentColor"
            />
            <path
                d="M20.1 14.3C19.605 14.3 19.2 14.705 19.2 15.2V18.431L14.439 13.67C14.088 13.319 13.521 13.319 13.17 13.67C12.819 14.021 12.819 14.588 13.17 14.939L17.931 19.7H14.7C14.205 19.7 13.8 20.105 13.8 20.6C13.8 21.095 14.205 21.5 14.7 21.5H20.1C20.217 21.5 20.334 21.473 20.442 21.428C20.658 21.338 20.838 21.158 20.928 20.942C20.973 20.834 21 20.717 21 20.6V15.2C21 14.705 20.595 14.3 20.1 14.3Z"
                fill="currentColor"
            />
            <path
                d="M6.069 5.3H9.3C9.795 5.3 10.2 4.895 10.2 4.4C10.2 3.905 9.795 3.5 9.3 3.5H3.9C3.783 3.5 3.666 3.527 3.558 3.572C3.333 3.662 3.162 3.833 3.072 4.058C3.027 4.166 3 4.283 3 4.4V9.8C3 10.295 3.405 10.7 3.9 10.7C4.395 10.7 4.8 10.295 4.8 9.8V6.569L9.561 11.33C9.741 11.51 9.966 11.591 10.2 11.591C10.434 11.591 10.659 11.501 10.839 11.33C11.19 10.979 11.19 10.412 10.839 10.061L6.069 5.3Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CrossIcon
